import { FAQ } from "../../Components/FAQ"
import { Footer } from "../../Components/Footer"
import { Header } from "../../Components/Header"

export const FAQS = () => {

    return (
        <>
        <Header />
        <FAQ />
        <Footer />
        </>
    )
}